import { createFileRoute } from "@tanstack/react-router";

import { EngagementResourcesList } from "./-components/engagement-resources-list";

export const Route = createFileRoute(
  "/_user/coaching/$engagementId/coaching-resources",
)({
  staticData: { title: "Coaching Resources" },
  component: RouteComponent,
});

function RouteComponent() {
  const { engagementId } = Route.useParams();

  return <EngagementResourcesList engagementId={engagementId} showTagFilter />;
}
